<h1 class="page-title pl-5 pt-2">Add User</h1>
<form class="grid grid-cols-2 gap-x-4 m-5" [formGroup]="userForm">

  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-input [control]="firstName" placeHolder="Enter first name" label="First Name" [required]="true"
      inputType="text" autocomplete="off" [maxLength]="50">
    </prism-input>
  </div>

  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-input [control]="lastName" placeHolder="Enter last name" label="Last Name" [required]="true" inputType="text"
      autocomplete="off" [maxLength]="50">
    </prism-input>
  </div>

  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-input [control]="emailName" placeHolder="Enter email" label="Email" [required]="true" inputType="email" autocomplete="off">
    </prism-input>
  </div>

  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-select-role [control]="roleId" label="Roles" [required]="true">
    </prism-select-role>
  </div>

  @if (roleId?.value === roles.User) {
  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-select-grade [control]="gradeIds" label="Grade Level" [required]="true" [multiSelect]="true">
    </prism-select-grade>
  </div>
  }

  @if (roleId?.value !== roles.SystemAdmin) {
  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-select-organization [control]="districtId" label="District" [required]="true" [readOnly]="isUser"
      [multiSelect]="roleId?.value !== roles.User">
    </prism-select-organization>
  </div>
  }
  @if (roleId?.value === roles.User && arrList.length > 0) {
  <div class="col-span-2 lg:col-span-1 items-center w-[100%] pb-4">
    <prism-select-school [control]="schoolId" label="School" [required]="true" [districtId]="districtId?.value?.[0]"
      [options]="schoolOptions">
    </prism-select-school>
  </div>
  }

  <div class="col-span-2 items-end w-full pb-4">
    <prism-btn
      btnClass="bg-dark-purple text-white font-bold border-2 mt-5 rounded-xl border-dark-purple w-full sm:w-auto"
      (click)="saveUser()">
      Save
    </prism-btn>
  </div>
</form>